import { render, staticRenderFns } from "./ebp-card.vue?vue&type=template&id=66a7dc48"
import script from "./ebp-card.vue?vue&type=script&lang=js"
export * from "./ebp-card.vue?vue&type=script&lang=js"
import style0 from "./ebp-card.vue?vue&type=style&index=0&id=66a7dc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports